import ContactHero from '../../components/ContactHero/ContactHero';
import ContactForm from '../../components/ContactForm/ContactForm';
import styles from './Contact.module.css';

const Contact = () => {
  return (
    <div className={styles.contactPage}>
        <ContactHero />
      <ContactForm />
    </div>
  );
};

export default Contact;
